import styled from "styled-components";

export const Backdrop = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`

export const ControlsBottom = styled.div`
  z-index: 10000;

  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${({ height }) => `${height}px`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  gap: 10px;
  background-color: rgba(0,0,0, .5);

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    padding: 0 10px;
  }
`

export const LeftControls = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`